import React from 'react';
import { Outlet } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import DashboardLayout from '../components/dashboard/DashboardLayout';
import { DeviceGate } from '../components/auth/OfflinePin';
import { useDeviceVault } from '../contexts/DeviceVaultContext';

const Dashboard = () => {
  const { user } = useAuth();
  const { identity } = useDeviceVault();
  
  return (
    <DeviceGate>
      <DashboardLayout userRole={(user || identity)?.role}>
        {/* Outlet will render the nested route components */}
        <Outlet />
      </DashboardLayout>
    </DeviceGate>
  );
};

export default Dashboard;
